/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

// Main imports
import $ from "jquery";
import jQuery from "jquery";
import anime from 'animejs/lib/anime.es.js';
require('./bootstrap');
require('slick-carousel');
require('magnific-popup');

// Aos scroll animations
import AOS from 'aos';
import 'aos/dist/aos.css';


// Form imports
window.Vue = require('vue');
import Vue from 'vue';
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);



/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))


Vue.component('main-nav', require('./components/MainNav.vue').default);
Vue.component('main-header', require('./components/MainHeader.vue').default);
Vue.component('main-teaser', require('./components/MainTeaser.vue').default);
Vue.component('main-steps', require('./components/MainSteps.vue').default);
Vue.component('main-prizes', require('./components/MainPrizes.vue').default);
Vue.component('main-products', require('./components/MainProducts.vue').default);
Vue.component('main-stores', require('./components/MainStores.vue').default);
Vue.component('main-video', require('./components/MainVideo.vue').default);
Vue.component('main-blog', require('./components/MainBlog.vue').default);
Vue.component('main-form', require('./components/MainForm.vue').default);
Vue.component('main-footer', require('./components/MainFooter.vue').default);
Vue.component('error-page', require('./components/404.vue').default);


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});




//Nav Menu Collapse & Hamburger
$(document).ready(function () {

    // Aos animations
    var width = $(window).width();
    if (width < 1200){
        AOS.init({
            disable: 'mobile',
            offset: 20,
            duration: 4000, 
            easing: 'ease-out-back'
        });
    } else {
        AOS.init({
            offset: 50,
            duration: 1000,
            easing: 'ease-out-back',
            once: 'true'
        });
    }

    $('body').css('overflow-x', 'hidden');
	
	// Sugestion section logic
	$('.sugestion--cta').click(function() {
		$('.sugestion__bg').css('background', '#d2effc');
		$('.sugestion__day--wrapper').css('font-size', '1.6rem');
		$('.sugestion__day--wrapper::before').css('width', '15px');
    $('.sugestion__day--wrapper::after').css('width', 'auto');
    // $(this).delay(500).fadeOut();
    $(this).slideUp();
	});

    // Remove AOS rewind animation for form elements on mobile devices
    if (width > 300) {
        $('.mobile-no-anim').attr('data-aos-once', 'true');
    } else {
        $('.mobile-no-anim').attr('data-aos-once', 'false');
    }

    // /change animations scroll offset on mobiles
    $(window).resize(function() {
		if (width < 1400){
			$('body').css('overflow-x', 'hidden');
		}
        var width = $(window).width();
        if (width < 1200){
            AOS.init({
                offset: 20,
                duration: 4000, 
                easing: 'ease-out-back'
            });
        }
    });

    //Hamburger Menu
    $('.hamburger').on('click', function () {
        $(this).toggleClass('open');
        $('.nav__menu').toggleClass('menu__mobile');
    });

    //Mobile Menu Collapse
    $('.nav__menu > a').on('click', function () {
        if ($(window).width() < 990) {
            $('.hamburger').removeClass('open');
            $('.nav__menu').toggleClass('menu__mobile');
        }
    });

    //Smooth Scroll
    $('a[href^="#"]').on('click', function (event) {
        if (!$(this).hasClass('noscroll--js')) {
            var target = $(this.getAttribute('href'));
            if (target.length) {
                event.preventDefault();
                $('html, body').stop().animate({
                    scrollTop: target.offset().top - 70
                }, 600);
            }
        }
        return false;
    });

    // Slick Carousel
    $('.header__slider').slick({
        initialSlide: 1,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: true,
        speed: 500,
        fade: true,
        autoplay: true,
        autoplaySpeed: 3000,
        variableWidth: false,
        pauseOnHover:false
    });

    $('.products__carousel').slick({
        dots: false,
        arrows: true,
        infinite: true,
        dots: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow:"<img class='a-left control-c prev slick-prev' src='../images/icons/arrow-left-icon.png'>",
        nextArrow:"<img class='a-right control-c next slick-next' src='../images/icons/arrow-right-icon.png'>",
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
    });

	// Articles Carousel
	$('[data-slick]').slick({
		fade: true,
		arrows: true,
		dots: false,
		infinite: true,
		prevArrow:"<img class='a-left control-c prev slick-prev' src='../images/bg/triangle-dots.png'>",
        nextArrow:"<img class='a-right control-c next slick-next' src='../images/bg/triangle-dots.png'>",
	});

	// Articles modals
	
	$('.popup-with-zoom-anim').magnificPopup({
		type: 'inline',

		fixedContentPos: false,
		fixedBgPos: true,

		overflowY: 'auto',

		closeBtnInside: true,
		preloader: false,
		
		midClick: true,
		removalDelay: 300,
		mainClass: 'my-mfp-zoom-in',
		callbacks: {
			open: function() {
			  $('body').addClass('noscroll');
			},
			close: function() {
			  $('body').removeClass('noscroll');
			}
		}
	});

	$(".article-close").click(function() {
		$.magnificPopup.close();
	});

    // Set nav a active state
    $(".nav__menu a").click(function () {
        $(this).addClass("nav__active").siblings().removeClass('nav__active');
    });

    // Change navbar styles on scroll
    $(window).scroll(function() {    
        var scroll = $(window).scrollTop();    
        if (scroll >= 5) {
            $(".nav").addClass("nav__scrolled");
        } else {
            $(".nav").removeClass("nav__scrolled");
        }
    });

    // Video section controls
    // poster frame click event
    $(document).on('click','.js-videoPoster',function(ev) {
        ev.preventDefault();
        var $poster = $(this);
        var $wrapper = $poster.closest('.js-videoWrapper');
        videoPlay($wrapper);
    });
  
    // play the targeted video (and hide the poster frame)
    function videoPlay($wrapper) {
            var $iframe = $wrapper.find('.js-videoIframe');
            var src = $iframe.data('src');
        
            // hide poster
            $wrapper.addClass('videoWrapperActive');
        
            // add iframe src in, starting the video
            $iframe.attr('src',src);
    }
  
    // stop the targeted/all videos (and re-instate the poster frames)
    function videoStop($wrapper) {
        // if we're stopping all videos on page
        if (!$wrapper) {
            var $wrapper = $('.js-videoWrapper');
            var $iframe = $('.js-videoIframe');

            // if we're stopping a particular video
        } else {
            var $iframe = $wrapper.find('.js-videoIframe');
        }

        // reveal poster
        $wrapper.removeClass('videoWrapperActive');

        // remove youtube link, stopping the video from playing in the background
        $iframe.attr('src','');
    }

    // Video autoplay control
    $('#pufina-video-spot-play').click(function() {
        $("#pufina-video-spot").attr('src', $("#pufina-video-spot", parent).attr('src') + '?autoplay=1'); 
    });

    // Scratch zone canvas script
    var Scratch = (function () {

        /**
         * Merge properties between two objects
         * @param obj1
         * @param obj2
         * @returns {{}}
         */
    function mergeOptions(obj1, obj2){
        var obj3 = {};
        for (var key in obj1) { obj3[key] = obj1[key]; }
        for (var key in obj2) { obj3[key] = obj2[key]; }
        return obj3;
    }

        /**
         * Generate a random number
         * @param min
         * @param max
         * @returns {Number}
         */
    function randomPoint(min, max) {
        var random = Math.abs(Math.random()*(max - min) + min);
        return random = parseInt(random.toFixed(0), 10);
    }

        /**
         * Scratch constructor
         * @param options
         * @constructor
         */
        var Scratch = function(options) {
            this.cursor = {
                png: '', // Modern browsers
                cur: '', // for IE
                    x: 20,
                    y: 20,
                    default: 'auto'
            };
            this.pointSize = {
                x: 15,
                y: 15
            };
        this.defaults = {
            canvasId: '', // Canvas id
            imageBackground: '', // Path [src]
            pictureOver: '', // Path [src]
            cursor: this.cursor, // Custom pointer
            sceneWidth: 400, // Canvas width
            sceneHeight: 250, // Canvas height
            radius: 40, // Radius of scratch zone
            nPoints: 10, // n points for clear canvas
            pointSize: this.pointSize,
            percent: null,
            callback: null
        };

        this.options = mergeOptions(this.defaults, options);
        this.options.cursor = mergeOptions(this.cursor, options.cursor);
        this.options.pointSize = mergeOptions(this.pointSize, options.pointSize);

        // init Scratch
            this.init();
        };

        Scratch.prototype.init = function () {
            var _this = this; // Save the "this" :)
            this.canvas = document.getElementById(this.options.canvasId);
            this.ctx = this.canvas.getContext('2d');
            this.canvas.width = this.options.sceneWidth;
            this.canvas.height = this.options.sceneHeight;
            this.image = new Image();
            this.image.src = this.options.pictureOver;
            this.percent = 0;
            this.zone = null;
            this.pixelRatio = window.devicePixelRatio;

            // Set background after draw the canvas
            this.setBackground();
            this.setCursor();

            var scratchMove = function(e) {
                e.preventDefault();
                _this.scratch(e);
            };

            window.addEventListener('resize', function() {
                _this.update();
                // Resize the canvas
            });

            window.addEventListener('scroll', function() {
                _this.update();
            });

            // Mouse & Touch events
            this.canvas.addEventListener('mousedown', function(e) {
                _this.canvas.addEventListener('mousemove', scratchMove);
            });
            this.canvas.addEventListener('mouseup', function _func(e) {
                _this.canvas.removeEventListener('mousemove', scratchMove);
                var clear = _this.clear();
                if (clear) {
                    _this.callback(_this.options.callback);
                    _this.canvas.removeEventListener('mouseup', _func);
                }
            });

            this.canvas.addEventListener('touchstart', function(e) {
                _this.canvas.addEventListener('touchmove', scratchMove);
            });
            this.canvas.addEventListener('touchend', function(e) {
                _this.canvas.removeEventListener('touchmove', scratchMove);
                var clear = _this.clear();
                if (clear) {
                    _this.callback(_this.options.callback);
                }
            });

        };

        Scratch.prototype.setCursor = function() {
            var string = '';

            if (document.documentElement.classList.contains('is-ie') || navigator.userAgent.indexOf('Trident') != -1 || navigator.userAgent.indexOf('Edge') != -1) {
                string += 'url(' + this.options.cursor.cur + '), auto';
            } else {
                string += 'url(' + this.options.cursor.png + ') ' + this.options.cursor.x + ' ' + this.options.cursor.y + ', pointer';
            }

            this.canvas.setAttribute('style', 'cursor:' + string + ';');
        };

        // Update positions etc
        Scratch.prototype.update = function() {
            this.zone = this.canvas.getBoundingClientRect();
        };

        Scratch.prototype.fluidify = function () {
            var imgData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
            this.canvas.width = window.innerWidth;
            this.canvas.height = window.innerHeight;
            this.ctx.putImageData(imgData, 0, 0);
        };

        Scratch.prototype.setBackground = function() {
            var _this = this;
            this.image.onload = function() {
                _this.zone = _this.canvas.getBoundingClientRect();
                // Draw image
                _this.ctx.drawImage(this, 0, 0, this.width * 0.73, this.height * 0.73);
                // When the canvas have been drawn
                var IMG = document.createElement('img');
                IMG.classList.add('scratch_picture-under');
                IMG.src = _this.options.imageBackground;
                _this.canvas.parentElement.insertBefore(IMG, _this.canvas);
            };
        };

        Scratch.prototype.clearPoint = function (x1, y1) {
            var radius = this.options.radius;
            var x = Math.random() * 2 * radius - radius;
            var ylim = Math.sqrt(radius * radius - x * x);
            var y = Math.random() * 2 * ylim - ylim;
            x += radius;
            y += radius;

            x = parseInt(x, 10);
            y = parseInt(y, 10);

            return {
                x: x + x1,
                y: y + y1
            }

        };


        Scratch.prototype.getPosition = function(e) {
            var posX, posY;
            switch (e.type) {
                case 'touchmove':
                    posX = e.touches[0].clientX - this.options.radius - window.pageXOffset;
                    posY = e.touches[0].clientY - this.options.radius - window.pageYOffset;
                    break;
                case 'mousemove':
                    posX = e.clientX - this.options.radius - window.pageXOffset;
                    posY = e.clientY - this.options.radius - window.pageYOffset;
                    break;
            }

            return {
                x: posX,
                y: posY
            }
        };

        Scratch.prototype.scratch = function(e) {
            var position = this.getPosition(e);
            var x = position.x - this.zone.left;
            var y = position.y - this.zone.top + window.pageYOffset;
            var i = 0;
            var len = this.options.nPoints;

            for(i; i<len; i++) {
                var points = this.clearPoint(x, y);
                this.ctx.clearRect(points.x, points.y, this.options.pointSize.x, this.options.pointSize.y);
            }
            this.percent = this.getPercent();
        };

        Scratch.prototype.getPercent = function() {
            var percent;
            var counter = 0; // number of pixels clear
            var imageData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
            var imageDataLength = imageData.data.length;

            for(var i = 0; i < imageDataLength; i += 4) {
            if (imageData.data[i] === 0 && imageData.data[i+1] === 0 && imageData.data[i+2] === 0 && imageData.data[i+3] === 0) {
                counter++;
            }
            }

            if (counter >= 1) {
                percent = (counter / (this.canvas.width * this.canvas.height)) * 100;
            } else {
                percent = 0;
            }
            return percent;
        };

        Scratch.prototype.clear = function() {
            if (this.percent >= this.options.percent) {
                this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
            return true;
            }
        };

        Scratch.prototype.callback = function(callback) {
            if (callback != null && this.percent >= this.options.percent) {
                callback();
            }
        };

        return Scratch;
    })();


    // Daily prizes scratch
    var scratch = new Scratch({
        canvasId: 'js-scratch-canvas',
        imageBackground: 'images/daily-prize-under.png',
        pictureOver: 'images/daily-prize-scratch.png',
        cursor: {
            png: 'images/icons/coin-logo.png',
            cur: 'drag',
            x: '20',
            y: '17'
        },
        radius: 30,
        nPoints: 100,
        percent: 30,
        pointSize: { x: 4, y: 4}
    });

    // Big prize scratch
    var scratch2 = new Scratch({
        canvasId: 'js-scratch-canvas-2',
        imageBackground: 'images/big-prize-under.png',
        pictureOver: 'images/big-prize-scratch.png',
        cursor: {
            png: 'images/icons/coin-logo.png',
            cur: 'drag',
            x: '20',
            y: '17'
        },
        radius: 30,
        nPoints: 100,
        percent: 30,
        pointSize: { x: 3, y: 3}
    });


    // Animated Circle
    function anim() {  
        var morphing = anime({
            targets: '#morphing .polymorph',
            points: [
                { value: '70 41 118.574 59.369 111.145 132.631 60.855 84.631 20.426 60.369' },
                { value: '70 6 119.574 60.369 100.145 117.631 39.855 117.631 55.426 68.369' },
                { value: '70 57 136.574 54.369 89.145 100.631 28.855 132.631 38.426 64.369' },
                { value: '70 24 119.574 60.369 100.145 117.631 50.855 101.631 3.426 54.369' }
            ],
            easing: 'easeOutQuad',
            duration: 4000,
            loop: true
        });
    }
    anim();
  
    function animLogo() {
        anime({
            targets: '#logo-base-path, #logo-base-path-2',
            // d: [{ value: '' }, { value: '' }], 
            d: "M 259.04104,0.01442282 C 164.4263,0.58553355 59.295072,15.616505 24.262606,100.36045 c -30.1160556,69.92572 -35.784833,154.81232 3.645885,222.38352 44.41051,79.4652 128.449739,153.49995 217.248239,153.5676 92.15978,0.9989 176.55777,-0.12245 232.97921,-76.86598 C 513.677,352.3599 520.18777,288.24523 500.85725,233.26065 464.63177,122.84026 413.15536,25.533345 298.49961,3.4277534 285.48899,1.0783349 272.26006,-0.14877975 259.04104,0.01442282 Z",
            // "M 235.95,0.013672 C 120.54,1.323072 -7.3098475,85.246627 1.88,239.54367 c 10.736116,149.43857 99.75287,246.36582 267.38,259.95 149.1657,9.69277 254.73287,-122.71409 263.85287,-229.27409 1.21,-13.92 0.69,-28.24 -1.69,-42.82 -3.5,-21.53 -9.88,-42.76 -18.71,-63.28 C 469.84287,64.423587 406.18265,9.5965684 265.54,1.873672 c -9.93,-1.3627 -19.81,-1.9673 -29.59,-1.8563 z",
            duration: 3000,
            loop: true,
            direction: "alternate",
            easing: "linear",
            elasticity: function(el, i, l) {
                return (200 + i * 200);
            }
        });
    }
  
    animLogo();
});




// //GDPR


(function($) {

    // for ie9 doesn't support debug console >>>
    if (!window.console) window.console = {};
    if (!window.console.log) window.console.log = function () { };
    // ^^^
    
    $.fn.euCookieLawPopup = (function() {
    
      var _self = this;
    
      ///////////////////////////////////////////////////////////////////////////////////////////////
      // PARAMETERS (MODIFY THIS PART) //////////////////////////////////////////////////////////////
      _self.params = {
        cookiePolicyUrl : 'https://www.pufina.ro/wp-content/uploads/2018/12/Politica_Cookies_Pufina.pdf',
        popupPosition : 'bottom',
        colorStyle : 'default',
        compactStyle : false,
        popupTitle : 'Distractie cu Familia folosește cookies',
        popupText : 'Pentru a oferi o experiență bună de utilizare folosim cookies. Puteți citi mai mult despre cookies în pagina <a taget="_blank" rel="noopener noreferer" href="https://www.pufina.ro/wp-content/uploads/2018/12/Politica_Cookies_Pufina.pdf">Politica cookie</a>.<br>Prin inchiderea acestui mesaj sau prin apăsarea pe "Continuare" vom considera ca sunteți de acord și acceptați politica cookies.',
        buttonContinueTitle : 'Continuare',
        buttonLearnmoreTitle : 'Mai multe informații despre cookie',
        buttonLearnmoreOpenInNewWindow : true,
        agreementExpiresInDays : 30,
        autoAcceptCookiePolicy : false,
        htmlMarkup : null
      };
    
      ///////////////////////////////////////////////////////////////////////////////////////////////
      // VARIABLES USED BY THE FUNCTION (DON'T MODIFY THIS PART) ////////////////////////////////////
      _self.vars = {
        INITIALISED : false,
        HTML_MARKUP : null,
        COOKIE_NAME : 'EU_COOKIE_LAW_CONSENT'
      };
    
      ///////////////////////////////////////////////////////////////////////////////////////////////
      // PRIVATE FUNCTIONS FOR MANIPULATING DATA ////////////////////////////////////////////////////
    
      // Overwrite default parameters if any of those is present
      var parseParameters = function(object, markup, settings) {
    
        if (object) {
          var className = $(object).attr('class') ? $(object).attr('class') : '';
          if (className.indexOf('eupopup-top') > -1) {
            _self.params.popupPosition = 'top';
          }
          else if (className.indexOf('eupopup-fixedtop') > -1) {
            _self.params.popupPosition = 'fixedtop';
          }
          else if (className.indexOf('eupopup-bottomright') > -1) {
            _self.params.popupPosition = 'bottomright';
          }
          else if (className.indexOf('eupopup-bottomleft') > -1) {
            _self.params.popupPosition = 'bottomleft';
          }
          else if (className.indexOf('eupopup-bottom') > -1) {
            _self.params.popupPosition = 'bottom';
          }
          else if (className.indexOf('eupopup-block') > -1) {
            _self.params.popupPosition = 'block';
          }
          if (className.indexOf('eupopup-color-default') > -1) {
            _self.params.colorStyle = 'default';
          }
          else if (className.indexOf('eupopup-color-inverse') > -1) {
            _self.params.colorStyle = 'inverse';
          }
          if (className.indexOf('eupopup-style-compact') > -1) {
            _self.params.compactStyle = true;
          }
        }
    
        if (markup) {
          _self.params.htmlMarkup = markup;
        }
    
        if (settings) {
          if (typeof settings.cookiePolicyUrl !== 'undefined') {
            _self.params.cookiePolicyUrl = settings.cookiePolicyUrl;
          }
          if (typeof settings.popupPosition !== 'undefined') {
            _self.params.popupPosition = settings.popupPosition;
          }
          if (typeof settings.colorStyle !== 'undefined') {
            _self.params.colorStyle = settings.colorStyle;
          }
          if (typeof settings.popupTitle !== 'undefined') {
            _self.params.popupTitle = settings.popupTitle;
          }
          if (typeof settings.popupText !== 'undefined') {
            _self.params.popupText = settings.popupText;
          }
          if (typeof settings.buttonContinueTitle !== 'undefined') {
            _self.params.buttonContinueTitle = settings.buttonContinueTitle;
          }
          if (typeof settings.buttonLearnmoreTitle !== 'undefined') {
            _self.params.buttonLearnmoreTitle = settings.buttonLearnmoreTitle;
          }
          if (typeof settings.buttonLearnmoreOpenInNewWindow !== 'undefined') {
            _self.params.buttonLearnmoreOpenInNewWindow = settings.buttonLearnmoreOpenInNewWindow;
          }
          if (typeof settings.agreementExpiresInDays !== 'undefined') {
            _self.params.agreementExpiresInDays = settings.agreementExpiresInDays;
          }
          if (typeof settings.autoAcceptCookiePolicy !== 'undefined') {
            _self.params.autoAcceptCookiePolicy = settings.autoAcceptCookiePolicy;
          }
          if (typeof settings.htmlMarkup !== 'undefined') {
            _self.params.htmlMarkup = settings.htmlMarkup;
          }
        }
    
      };
    
      var createHtmlMarkup = function() {
    
        if (_self.params.htmlMarkup) {
          return _self.params.htmlMarkup;
        }
    
        var html =
          '<div class="eupopup-container' +
              ' eupopup-container-' + _self.params.popupPosition +
              (_self.params.compactStyle ? ' eupopup-style-compact' : '') +
            ' eupopup-color-' + _self.params.colorStyle + '">' +
            '<div class="eupopup-head">' + _self.params.popupTitle + '</div>' +
            '<div class="eupopup-body">' + _self.params.popupText + '</div>' +
            '<div class="eupopup-buttons">' +
              '<a href="#" class="eupopup-button eupopup-button_1">' + _self.params.buttonContinueTitle + '</a>' +
              '<a href="' + _self.params.cookiePolicyUrl + '"' +
               (_self.params.buttonLearnmoreOpenInNewWindow ? ' target=_blank ' : '') +
              ' class="eupopup-button eupopup-button_2">' + _self.params.buttonLearnmoreTitle + '</a>' +
              '<div class="clearfix"></div>' +
            '</div>' +
            '<a href="#" class="eupopup-closebutton">x</a>' +
          '</div>';
    
        return html;
      };
    
      // Storing the consent in a cookie
      var setUserAcceptsCookies = function(consent) {
        var d = new Date();
        var expiresInDays = _self.params.agreementExpiresInDays * 24 * 60 * 60 * 1000;
        d.setTime( d.getTime() + expiresInDays );
        var expires = "expires=" + d.toGMTString();
        document.cookie = _self.vars.COOKIE_NAME + '=' + consent + "; " + expires + ";path=/";
    
        $(document).trigger("user_cookie_consent_changed", {'consent' : consent});
      };
    
      // Let's see if we have a consent cookie already
      var userAlreadyAcceptedCookies = function() {
        var userAcceptedCookies = false;
        var cookies = document.cookie.split(";");
        for (var i = 0; i < cookies.length; i++) {
          var c = cookies[i].trim();
          if (c.indexOf(_self.vars.COOKIE_NAME) == 0) {
            userAcceptedCookies = c.substring(_self.vars.COOKIE_NAME.length + 1, c.length);
          }
        }
    
        return userAcceptedCookies;
      };
    
      var hideContainer = function() {
        // $('.eupopup-container').slideUp(200);
        $('.eupopup-container').animate({
          opacity: 0,
          height: 0
        }, 200, function() {
          $('.eupopup-container').hide(0);
        });
      };
    
      ///////////////////////////////////////////////////////////////////////////////////////////////
      // PUBLIC FUNCTIONS  //////////////////////////////////////////////////////////////////////////
      var publicfunc = {
    
        // INITIALIZE EU COOKIE LAW POPUP /////////////////////////////////////////////////////////
        init : function(settings) {
    
          parseParameters(
            $(".eupopup").first(),
            $(".eupopup-markup").html(),
            settings);
    
          // No need to display this if user already accepted the policy
          if (userAlreadyAcceptedCookies()) {
            $(document).trigger("user_cookie_already_accepted", {'consent': true});
            return;
          }
    
          // We should initialise only once
          if (_self.vars.INITIALISED) {
            return;
          }
          _self.vars.INITIALISED = true;
    
          // Markup and event listeners >>>
          _self.vars.HTML_MARKUP = createHtmlMarkup();
    
          if ($('.eupopup-block').length > 0) {
            $('.eupopup-block').append(_self.vars.HTML_MARKUP);
          } else {
            $('BODY').append(_self.vars.HTML_MARKUP);
          }
    
          $('.eupopup-button_1').click(function() {
            setUserAcceptsCookies(true);
            hideContainer();
            return false;
          });
          $('.eupopup-closebutton').click(function() {
            setUserAcceptsCookies(true);
            hideContainer();
            return false;
          });
          // ^^^ Markup and event listeners
    
          // Ready to start!
          $('.eupopup-container').show();
    
          // In case it's alright to just display the message once
          if (_self.params.autoAcceptCookiePolicy) {
            setUserAcceptsCookies(true);
          }
    
        }
    
      };
    
      return publicfunc;
    });
    
    $(document).ready( function() {
      if ($(".eupopup").length > 0) {
        $(document).euCookieLawPopup().init({
          'info' : 'YOU_CAN_ADD_MORE_SETTINGS_HERE',
          'popupTitle' : 'Distractie cu Familia folosește cookies',
          'popupText' : 'Pentru a oferi o experiență bună de utilizare folosim cookies. Puteți citi mai mult despre cookies în pagina <a taget="_blank" rel="noopener noreferer" href="https://www.pufina.ro/wp-content/uploads/2018/12/Politica_Cookies_Pufina.pdf">Politica Cookie</a>.<br>Prin inchiderea acestui mesaj sau prin apăsarea pe "Continuare" vom considera ca sunteți de acord și acceptați politica cookies.'
        });
      }
    });
    
    $(document).bind("user_cookie_consent_changed", function(event, object) {
      console.log("User cookie consent changed: " + $(object).attr('consent') );
    });
    
    }(jQuery));